import { render } from "./GridKontrabonDetail.vue?vue&type=template&id=25aa3b8a"
import script from "./GridKontrabonDetail.vue?vue&type=script&lang=js"
export * from "./GridKontrabonDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__